import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SectionLabel, LuxBg } from "../Reveal";
import { MANIFESTO_PARAGRAPH } from "../../content";

gsap.registerPlugin(ScrollTrigger);

const LINES = [
  { text: "VA HOME LOANS", cls: "text-white" },
  { text: "SHOULD NOT FEEL", cls: "text-white" },
  { text: "LIKE DECODING", cls: "text-white" },
  { text: "FINE PRINT.", cls: "text-[#FE0000]" },
];

export const Manifesto = () => {
  const ref = useRef(null);

  useEffect(() => {
    const words = ref.current.querySelectorAll(".manifesto-word");
    const tween = gsap.fromTo(
      words,
      { opacity: 0, y: 24 },
      {
        opacity: 1,
        y: 0,
        stagger: 0.04,
        duration: 0.7,
        ease: "power3.out",
        scrollTrigger: { trigger: ref.current, start: "top 72%" },
      }
    );
    return () => { tween.scrollTrigger?.kill(); tween.kill(); };
  }, []);

  return (
    <section className="relative py-28 md:py-40 px-6 sm:px-10 lg:px-16 xl:px-24 overflow-hidden" data-testid="manifesto-section">
      <LuxBg n={2} />
      <div className="absolute right-8 top-1/2 -translate-y-1/2 hidden lg:grid grid-cols-8 gap-2" aria-hidden="true">
        {Array.from({ length: 64 }).map((_, i) => (
          <div key={i} className="w-3 h-3 bg-[#FE0000]/[0.06]" />
        ))}
      </div>
      <SectionLabel num="001" text="THE PROBLEM" />
      <div ref={ref}>
        <h2 className="serif font-black uppercase tracking-[-0.02em] text-[clamp(36px,5vw,68px)]" style={{ lineHeight: 0.97 }} data-testid="manifesto-statement">
          {LINES.map((l, li) => (
            <span key={li} className={`block ${l.cls}`}>
              {l.text.split(" ").map((w, wi) => (
                <span key={wi} className="manifesto-word inline-block mr-[0.28em]">{w}</span>
              ))}
            </span>
          ))}
        </h2>
      </div>
      <p className="text-white text-base leading-[1.75] max-w-[560px] mt-10" data-testid="manifesto-paragraph">
        {MANIFESTO_PARAGRAPH}
      </p>
      <button
        data-testid="manifesto-cta"
        data-cta
        onClick={() => document.getElementById("register")?.scrollIntoView({ behavior: "smooth" })}
        className="mt-10 border border-[#FFE100] text-[#FFE100] font-bold text-sm uppercase tracking-wide px-8 py-4 rounded-md btn-slide"
      >
        SHOW ME THE MAP →
      </button>
    </section>
  );
};
